export default __webpack_public_path__ + "577720b65906f4d5608b189887a9f8da.obj";